export default [
  {
    title: "MQDC Reports",
    customIcon: "ReportSVG",
    children: [
      {
        title: "Issue Report",
        route: "custom-module",
        path: "/custom-module/issue",
      },
      {
        title: "Spin Wheel Report",
        route: "custom-module",
        path: "/custom-module/gameissue",
      },
      {
        title: "Activity Report",
        route: "custom-module",
        path: "/custom-module/activity-report",
      },
      {
        title: "Customer List Report",
        route: "custom-module",
        path: "/custom-module/customerReportList",
      },
      {
        title: "Attendee List Reprot",
        route: "custom-module",
        path: "/custom-module/checkinactivity",
      },
      {
        title: "Selection&Redemption Breakfast",
        route: "custom-module",
        path: "/custom-module/breakfastreport",
      },
      {
        title: "Raw data breakfast redemption",
        route: "custom-module",
        path: "/custom-module/breakrawdatafastreport",
      },
      {
        title: "Raw data Whiz Byte Survey",
        route: "custom-module",
        path: "/custom-module/surveyrawdatareport",
      },
      {
        title: "Whizbyte Add Stock For Staff",
        route: "custom-module",
        path: "/custom-module/addstockforstaffreport",
      },
    ],
  },
];
